import { NgModule } from '@angular/core'

// Form-specific PrimeNG modules
import { TextareaModule } from 'primeng/textarea'
import { InputNumberModule } from 'primeng/inputnumber'
import { InputMaskModule } from 'primeng/inputmask'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { PasswordModule } from 'primeng/password'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { KeyFilterModule } from 'primeng/keyfilter'
import { CheckboxModule } from 'primeng/checkbox'
import { DatePickerModule } from 'primeng/datepicker'

/**
 * Forms-specific PrimeNG module for form controls and inputs.
 * Import this only in modules that need form functionality.
 */
@NgModule({
  exports: [
    TextareaModule,
    InputNumberModule,
    InputMaskModule,
    ToggleSwitchModule,
    PasswordModule,
    AutoCompleteModule,
    KeyFilterModule,
    CheckboxModule,
    DatePickerModule,
  ],
})
export class FormsPrimeNGModule {}
